import { render, staticRenderFns } from "./CoozzyDropdownSpaceDivider.vue?vue&type=template&id=035249c8&scoped=true"
import script from "./CoozzyDropdownSpaceDivider.vue?vue&type=script&lang=js"
export * from "./CoozzyDropdownSpaceDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035249c8",
  null
  
)

export default component.exports